const FormContact = {
  init: () => {
    const formEl = document.getElementById("form-contact");

    if (formEl) {
      formEl.addEventListener("submit", (e) => {
        e.preventDefault();

        // update btn status
        FormContact.setBtnState(e.target, "send");

        // handle submit
        FormContact.handleSubmit(e);
      });
    }
  },

  setBtnState: (form, status) => {
    if (form) {
      const btn = form.querySelector(".btn");
      const btnTxt = btn ? btn.querySelector(".btn__text") : null;

      // default btn status strings
      let btnTxtDefault = "Submit";
      let btnTxtError = "Something went wrong.";
      let btnTxtSending = "Sending...";
      let btnTxtSuccess = "Thank you!";

      // get translated status strings
      if (btnTxt) {
        btnTxtDefault = btnTxt.dataset.default;
        btnTxtError = btnTxt.dataset.error;
        btnTxtSending = btnTxt.dataset.sending;
        btnTxtSuccess = btnTxt.dataset.success;
      }

      if (btn) {
        if (status == "send") {
          btn.disabled = true;
          btn.classList.add("animate--pulsate");
          if (btnTxt) btnTxt.innerText = btnTxtSending;
        } else {
          btn.disabled = false;
          btn.classList.remove("animate--pulsate");

          if (status == "ok") {
            if (btnTxt) btnTxt.innerText = btnTxtSuccess;
          } else {
            if (btnTxt) btnTxt.innerText = btnTxtError;
          }
        }
      }
    }
  },

  encodeData: (data) => {
    const payload = [];

    for (const [key, value] of Object.entries(data)) {
      payload.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    }

    return payload.join("&");
  },

  handleSubmit: (e) => {
    // submitted form
    const currentForm = e.target;

    // wp ajax url
    const url = siteData.ajaxUrl;

    // create new FormData from form
    const formData = new FormData(e.target);

    // create obj from FormData entries
    const formEntries = Object.fromEntries(formData);

    // prepare data
    const data = {
      action: "bswp_contact_form_submit",
      nonce: siteData.nonce,
      ...formEntries,
    };

    // encode data before submitting
    const payload = FormContact.encodeData(data);

    // setup fetch options
    const options = {
      method: "POST",
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: payload,
    };

    fetch(url, options)
      .then((res) => {
        // promise returned
        if (!res.ok) throw new Error(`HTTP error: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        // success
        //console.log(data);

        // clear form to prevent spamming
        currentForm.reset();

        // update btn status
        FormContact.setBtnState(currentForm, "ok");
      })
      .catch((err) => {
        // error
        console.log(err);

        // update btn status
        FormContact.setBtnState(currentForm, "error");
      });
  },
};

export default FormContact;
